import { alpha, Alert, Chip, Paper, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { SLOT_STATUS_META } from "../../pages/trainer/trainerUtils";
import TrainerCalendarControls from "./TrainerCalendarControls";
import TrainerMonthView from "./TrainerMonthView";
import TrainerSiteFilter from "./TrainerSiteFilter";
import TrainerWeekView from "./TrainerWeekView";

export default function TrainerPlanView({ isMobile, plan }) {
  const theme = useTheme();
  const {
    trainerSites,
    allSiteIds,
    selectedSiteIds,
    activeSites,
    hasSessions,
    hasSlots,
    rangeSummary,
    calendarView,
    rangeLabel,
    weekDateValues,
    todayValue,
    selectedDayIndex,
    slotsByDate,
    monthCells,
    selectedMonthDateValue,
    selectedMonthSlots,
    selectedMonthDateLabel,
    selectedMonthSiteCount,
    selectedMonthOverview,
    mobileFocusCue,
    mobileWeekRevealRefs,
    mobileMonthDetailsRef,
    onToggleSite,
    onSelectAllSites,
    onNavigate,
    onToday,
    onToggleCalendarView,
    onSelectWeekDay,
    onSelectMonthDate,
    onOpenSlot,
  } = plan;

  return (
    <>
      <TrainerSiteFilter
        trainerSites={trainerSites}
        allSiteIds={allSiteIds}
        selectedSiteIds={selectedSiteIds}
        onToggleSite={onToggleSite}
        onSelectAllSites={onSelectAllSites}
      />

      <TrainerCalendarControls
        calendarView={calendarView}
        isMobile={isMobile}
        rangeLabel={rangeLabel}
        rangeSummary={rangeSummary}
        onNavigate={onNavigate}
        onToday={onToday}
        onToggleCalendarView={onToggleCalendarView}
      />

      {!activeSites.length && (
        <Alert severity="info">
          Aktiviere mindestens einen Standort, damit der Kalender befüllt werden
          kann.
        </Alert>
      )}

      {activeSites.length > 0 && !hasSessions && (
        <Alert severity="info">
          Für die ausgewählten Standorte ist noch kein Trainingsplan hinterlegt.
        </Alert>
      )}

      {activeSites.length > 0 && hasSessions && !hasSlots && (
        <Alert severity="info">
          In diesem Zeitraum sind keine Trainings geplant.
        </Alert>
      )}

      {activeSites.length > 0 && hasSessions && (hasSlots || calendarView === "month") && (
        <>
          {calendarView === "week" ? (
            <TrainerWeekView
              isMobile={isMobile}
              weekDateValues={weekDateValues}
              slotsByDate={slotsByDate}
              todayValue={todayValue}
              selectedDayIndex={selectedDayIndex}
              mobileFocusCue={mobileFocusCue}
              mobileWeekRevealRefs={mobileWeekRevealRefs}
              onSelectWeekDay={onSelectWeekDay}
              onOpenSlot={onOpenSlot}
            />
          ) : (
            <TrainerMonthView
              isMobile={isMobile}
              monthCells={monthCells}
              slotsByDate={slotsByDate}
              todayValue={todayValue}
              rangeSummary={rangeSummary}
              selectedMonthDateValue={selectedMonthDateValue}
              selectedMonthSlots={selectedMonthSlots}
              selectedMonthDateLabel={selectedMonthDateLabel}
              selectedMonthSiteCount={selectedMonthSiteCount}
              selectedMonthOverview={selectedMonthOverview}
              mobileFocusCue={mobileFocusCue}
              mobileMonthDetailsRef={mobileMonthDetailsRef}
              onNavigate={onNavigate}
              onSelectMonthDate={onSelectMonthDate}
              onOpenSlot={onOpenSlot}
            />
          )}
        </>
      )}

      {isMobile && hasSlots && (
        <Paper
          elevation={0}
          sx={{
            position: "sticky",
            bottom: 0,
            mx: -2,
            px: 2,
            py: 1,
            borderTop: "1px solid",
            borderColor: "divider",
            backgroundColor: alpha(theme.palette.background.paper, 0.92),
            backdropFilter: "blur(8px)",
            zIndex: 10,
          }}
        >
          <Stack direction="row" spacing={1} justifyContent="center">
            <SummaryChip label={`${rangeSummary.open} offen`} meta={SLOT_STATUS_META.open} />
            <SummaryChip label={`${rangeSummary.mine} meine`} meta={SLOT_STATUS_META.mine} />
            <SummaryChip
              label={`${rangeSummary.occupied} besetzt`}
              meta={SLOT_STATUS_META.occupied}
            />
          </Stack>
        </Paper>
      )}
    </>
  );
}

function SummaryChip({ label, meta }) {
  return (
    <Chip
      size="small"
      label={label}
      sx={{
        backgroundColor: meta.bg,
        color: meta.text,
        fontWeight: 700,
      }}
    />
  );
}
